import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-adminlogin',
  templateUrl: './adminlogin.component.html',
  styleUrls: ['./adminlogin.component.scss']
})
export class AdminloginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
